import * as pdfjsLib from 'pdfjs-dist';

// Worker вже налаштований в fileTextExtractor.js

/**
 * Конвертує сторінку PDF в base64 зображення
 * @param {PDFPageProxy} page - Сторінка PDF
 * @param {number} scale - Масштаб (чим більше, тим краща якість)
 * @returns {Promise<string>} - Base64 зображення
 */
const convertPageToImage = async (page, scale = 2) => {
  const viewport = page.getViewport({ scale });

  // Створюємо canvas
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.height = viewport.height;
  canvas.width = viewport.width;

  // Рендеримо сторінку на canvas
  const renderContext = {
    canvasContext: context,
    viewport: viewport
  };

  await page.render(renderContext).promise;

  // Конвертуємо canvas в base64
  // Використовуємо JPEG для меншого розміру (якість 0.9)
  return canvas.toDataURL('image/jpeg', 0.9);
};

/**
 * Конвертує всі сторінки PDF в масив base64 зображень
 * @param {File} file - PDF файл
 * @param {number} maxPages - Максимальна кількість сторінок (для обмеження розміру запиту)
 * @returns {Promise<Array<string>>} - Масив base64 зображень
 */
export const convertPdfToImages = async (file, maxPages = 3) => {
  try {
    console.log('Converting PDF to images...');
    const arrayBuffer = await file.arrayBuffer();

    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;

    console.log(`PDF loaded, total pages: ${pdf.numPages}, converting max: ${maxPages}`);

    const pagesToConvert = Math.min(pdf.numPages, maxPages);
    const images = [];

    for (let pageNum = 1; pageNum <= pagesToConvert; pageNum++) {
      console.log(`Converting page ${pageNum}/${pagesToConvert} to image...`);
      const page = await pdf.getPage(pageNum);
      const imageBase64 = await convertPageToImage(page);
      images.push(imageBase64);
      console.log(`Page ${pageNum} converted, size: ${Math.round(imageBase64.length / 1024)}KB`);
    }

    console.log(`PDF conversion completed, total images: ${images.length}`);
    return images;
  } catch (error) {
    console.error('Error converting PDF to images:', error);
    throw new Error(`Failed to convert PDF to images: ${error.message}`);
  }
};

/**
 * Перевіряє, чи PDF містить текстовий слой
 * @param {File} file - PDF файл
 * @returns {Promise<boolean>} - true якщо є текст
 */
export const pdfHasTextLayer = async (file) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;

    // Перевіряємо першу сторінку
    const page = await pdf.getPage(1);
    const textContent = await page.getTextContent();

    return textContent.items.length > 0;
  } catch (error) {
    console.error('Error checking PDF text layer:', error);
    return false;
  }
};
